<template>
  <div class="internal-job-pool-container">
    <b-row class="d-flex justify-content-between align-items-center mx-1">
      <div class="d-flex flex-row">
        <h4>
          <template v-if="loading">Loading...</template>
          <template v-else>{{ results.edges.length | plural('result') }}</template>
        </h4>
      </div>
    </b-row>

    <!-- matched users card -->
    <b-card class="mt-3" v-if="results && Array.isArray(results.edges)">
      <b-row class="pb-3 border-bottom">
        <b-col class="block-title">Mentor Requests</b-col>
      </b-row>
      <b-row>
        <b-col class="px-0">
          <b-table
            table-class="m-0"
            hover responsive show-empty
            :fields="fields"
            :items="results.edges"
            :per-page="10"
            :current-page="page"
            :busy="false"
          >
            <template #table-busy>
              <div class="text-center my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Loading...</strong>
              </div>
            </template>
          </b-table>

          <b-card class="mt-3 border-0" body-class="d-flex flex-row p-3 justify-content-center align-items-center">
            <b-pagination
              class="m-0"
              v-model="page"
              :per-page="limit"
              :total-rows="total"
            />
          </b-card>
        </b-col>
      </b-row>
    </b-card>

  </div>
</template>

<script>
import LoadingSpinner from '@/components/misc/LoadingSpinner';
import { mapRoot } from '@src/mixins/root';

export default {
  name: 'InternalTalentPoolContainer',
  props: {
    loading: {
      type: Boolean,
      default: () => false,
    },
    hidePagination: {
      type: Boolean,
      default: () => false,
    },
    mentorRequests: {
      type: Array,
      default: () => ([]),
    },
  },
  components: {
    LoadingSpinner,
  },
  data() {
    return {
      results: {
        edges: this.mentorRequests ? this.mentorRequests : []
      },
      page: 1,
      limit: 10,
      total: (this.mentorRequests ? this.mentorRequests : []).length,
      totalPages: Math.ceil((this.mentorRequests ? this.mentorRequests : []).length / 10),
    };
  },
  computed: {
    ...mapRoot([ 'company', 'user' ]),
    fields() {
      return [
        {
          key: 'mentor.fullName',
          label: 'Name',
          thStyle: { width: '250px' },
        },
        {
          key: 'mentor.emailAddress',
          label: 'Email Address',
          thStyle: { width: '140px' },
        },
        {
          key: 'skills',
          label: 'Skills',
          thStyle: { width: '250px' },
          formatter: value => Array.isArray(value) ? value.join(', ') : ' - '
        },
        {
          key: 'status',
          label: 'Status',
          thStyle: { width: '120px' },
        },
      ];
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/mentors/MentorRequestsContainer.vue